import { render } from "./ChatBotPurchaseEditorCmp.vue?vue&type=template&id=2c32a84e"
import script from "./ChatBotPurchaseEditorCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotPurchaseEditorCmp.vue?vue&type=script&lang=js"

import "./ChatBotPurchaseEditorCmp.vue?vue&type=style&index=0&id=2c32a84e&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__